import template from './helloPackDealOption.html';
import controller from './helloPackDealOptionCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    familyId: '<',
    handler: '<',
    onChange: '&',
    isMultiple: '<',
    loanScenarioId: '<',
  },
};
